<script>
import { mapActions } from "vuex";
import i18n from "@/plugins/i18n";
import "vue-pdf-app/dist/icons/main.css";
import PDFViewer from "./pdf.vue";
export default {
  name: "Project Search Engine",
  components: {
    PDFViewer,
  },
  data() {
    return {
      searchModal: true,
      searchString: "",
      searchCount: 250, /* can change */
      loadingSearchTable: false,
      searchs: [],
      _searchs: [],
      headers: [
        {
          key: "participant_name",
          label: i18n.t("projectSearchEngine.header.participant_name"),
          flex: 0.2
        },
        {
          key: "ownership",
          label: i18n.t("projectSearchEngine.header.ownership"),
          flex: 0.2
        },
        {
          key: "org_type",
          label: i18n.t("projectSearchEngine.header.org_type"),
          flex: 0.075
        },
        {
          key: "sector",
          label: i18n.t("projectSearchEngine.header.sector"),
          flex: 0.075
        },
        {
          key: "country",
          label: i18n.t("projectSearchEngine.header.country"),
          flex: 0.075
        },
        {
          key: "sub_region",
          label: i18n.t("projectSearchEngine.header.sub_region"),
          flex: 0.075
        },
        {
          key: "region",
          label: i18n.t("projectSearchEngine.header.region"),
          flex: 0.075
        },
        {
          key: "file_language",
          label: i18n.t("projectSearchEngine.header.file_language"),
          flex: 0.075
        },
        {
          key: "published",
          label: i18n.t("projectSearchEngine.header.published"),
          flex: 0.075
        },
        {
          key: "file_url",
          label: i18n.t("projectSearchEngine.header.file_url"),
          flex: 0.075
        },
      ],
      searchedString: "",
      searchedCount: 10,
      pdfModal: false,
      reportNameModal: "",
      pdfItem: "",

      ascending: true,
      base: "",

      // for filtering options //
      
      countries: [],
      regions: [ //???????????????????????????//
        'Africa',
        'Americas',
        'Asia',
        'Europe',
        'Oceania'
      ],
      subRegions: [ //???????????????????????????//
        'Northern Africa',
        'Sub-Saharan Africa',
        'Latin America and the Caribbean',
        'Northern America',
        'Central Asia',
        'Eastern Asia',
        'South-eastern Asia',
        'Southern Asia',
        'Western Asia',
        'Eastern Europe',
        'Northern Europe',
        'Southern Europe',
        'Western Europe',
        'Australia and New Zealand',
        'Melanesia',
        'Micronesia',
        'Polynesia'
      ],
      sectors: [],
      languages: [ //??????????????????????????? what am i even doing//
        'Turkish',
        'English',
        'German',
        'Spanish',
        'Italian',
        'Portuguese',
        'Japanese',
        'Korean',
        'Arabic',
        'Russian',
        'Ukranian',
        'Serbian',
        'Hindi',
        'French',
        'Chinese',
        'Greek',
        'Croatian',
        'Polish',
        'Lithuanian',
        'Latvian',
        'Estonian',
        'Czech',
        'Icelandic'
      ],

      filterModal: false,

      filters: {
        sector: "",
        country: "",
        region: "",
        sub_region: "",
        file_language: ""
      }
    };
  },
  computed: {
    disabledControl() {
      const searchNumber = parseInt(this.searchCount, 10);
      return (
        this.searchString &&
        !isNaN(searchNumber) &&
        Number.isInteger(searchNumber)
      );
    },
  },
  mounted() {
    /* this.$toast.open({
      message: i18n.t("projectSearchEngine.toastTitle"),
      type: "info",
      duration: 5000,
      dismissible: true,
    }); */

    this.getCountries();
    this.getSectors();
  },
  methods: {
    ...mapActions("projectsearchengine", ["search"]),

    searchRequest() {
      this.searchs = [];
      this.searchModal = false;
      this.loadingSearchTable = true;
      this.searchedString = this.searchString;
      this.searchedCount = this.searchCount;
      let params = {
        q: this.searchString,
        size: this.searchCount,
      };
      for (const key in this.filters) {
        if (Object.hasOwnProperty.call(this.filters, key)) {
          const element = this.filters[key];
          
          params[key] = element;
        }
      }

      this.search(params)
        .then((res) => {
          this.searchModal = false;
          const data = res.data.results.results.best_matches;

          for (let index = 0; index < data.length; index++) {
            const element = data[index];
            this.searchs.push(element);
          }

          const deepCopy = this.searchs;
          this._searchs = deepCopy;
        })
        .catch(({ response }) => {
          this.searchModal = true;
          this.$toast.open({
            message: this.$parseResMessage(response.data.messageName),
            type: "error",
            duration: 5000,
            dismissible: true,
          });
        })
        .finally(() => {
          this.loadingSearchTable = false;
        });
    },
    openPdfModal(data) {
      this.pdfModal = true;
      this.reportNameModal = data.participant_name;
      this.pdfItem = data.file_url;
    },


    sortProjectsAlphabetically(_input, _base) {
      if(_base != this.base) {
        this.ascending = true;
      } else {
        this.ascending = !this.ascending;
      }
      
      this.searchs = this.$sortAlphabetically(_input, _base, this.ascending);
      this.base = _base;
    },
    sortProjectsByDate(_input, _base) {
      if(_base != this.base) {
        this.ascending = true;
      } else {
        this.ascending = !this.ascending;
      }
      
      this.searchs = this.$sortDates(_input, _base, this.ascending);
      this.base = _base;
    },

    ascendingCheck(base){
      return !this.ascending && (this.base == base) 
    },
    descendingCheck(base){
      return this.ascending && (this.base == base) 
    },

    sorterController(index, input, base) {
      if (index < 8) {
        this.sortProjectsAlphabetically(input, base);
      } else if (index == 8){
        this.sortProjectsByDate(input, base);
      } else {
        return;
      }
    },

    // FILTERING //


    ...mapActions('company', ['allCountry', 'getSector']),

    getCountries() {
      this.allCountry().then( res => {
        const data = res.data.data;

        data.forEach( item => {
          this.countries.push( item.name )
        })
      })
    },
    getSectors() {
      this.getSector({'is_deleted': false}).then( res => {
        const data = res.data;

        data.forEach( item => {
          this.sectors.push( item.sust_sector_name );
        })
      })
    },

    openFilterModal() {
      this.filterModal = true;
    },
    resetFilters() {
      this.filters = {
        "sector": "",
        "country": "",
        "region": "",
        "sub_region": "",
        "file_language": ""
      }
    },
    resetFilter(key) {
      this.filters[key] = "";
    }
  },
};
</script>

<template>
  <div class="p-3">
    <div class="row justify-content-between pt-4">
      <div class="searchbar">
        <input type="text" id="project-search"
          :placeholder="$t('supplierMetrics.metrics.search')" v-model="searchString" v-on:keyup.enter="searchRequest"
        >
        <b-icon icon="search" class="search-icon" @click="searchRequest" />
      </div>
      <div class="filter-button" @click="openFilterModal()">
        {{ $t('projectSearchEngine.filterModule.filter')}}
      </div>
    </div>

    <div class="pse-results-table">
      <div class="pse-headers">
        <div class="pse-header" v-for="(item, index) in headers" :key="index"
          @click="sorterController(index, searchs, item.key)"
          :style="{flex: item.flex}" :class="{'pse-pdf-header': index == 9}"
        >
          {{ item.label }}
          <i class="fa-solid fa-chevron-down sort-indicator" v-if="ascendingCheck(item.key)"></i>
          <i class="fa-solid fa-chevron-up sort-indicator" v-if="descendingCheck(item.key)"></i>
        </div>
      </div>

      <div class="pse-rows-wrapper" v-if="searchs.length > 0">
        <div class="pse-rows" v-for="(item, index) in searchs" :key="index">
          <div :style="{flex: headers[0].flex}" class="pse-cell">{{ item.participant_name }}</div>
          <div :style="{flex: headers[1].flex}" class="pse-cell">{{ item.ownership }}</div>
          <div :style="{flex: headers[2].flex}" class="pse-cell">{{ item.org_type }}</div>
          <div :style="{flex: headers[3].flex}" class="pse-cell">{{ item.sector }}</div>
          <div :style="{flex: headers[4].flex}" class="pse-cell">{{ item.country }}</div>
          <div :style="{flex: headers[5].flex}" class="pse-cell">{{ item.sub_region }}</div>
          <div :style="{flex: headers[6].flex}" class="pse-cell">{{ item.region }}</div>
          <div :style="{flex: headers[7].flex}" class="pse-cell">{{ item.file_language }}</div>
          <div :style="{flex: headers[8].flex}" class="pse-cell">{{ item.published }}</div>
          <div :style="{flex: headers[9].flex}" class="pse-cell pdf-cell">
            <i class="fa-solid fa-file-pdf" @click="openPdfModal(item)"></i>
          </div>
        </div>
      </div>

      <div v-else style="width: 100%;">
        <div v-if="loadingSearchTable" class="flex-all-centered-row pt-5">
          <b-spinner style="color: var(--sustainfinity-green);" class="align-middle"></b-spinner>
        </div>
        <div v-else class="col-12 p-4 text-center surveys" style="border-bottom-left-radius: 30px; border-bottom-right-radius: 30px;">
          <h5>{{ $t("noData.text") }}</h5>
        </div>
      </div>
    </div>

    <br /><br /><br />

    
    <b-modal
      v-model="pdfModal"
      ref="modal"
      :title="reportNameModal"
      centered
      size="xl"
    >
      <b-container class="bv-example-row">
        <b-row class="text-center">
          <b-col cols="12">
            <PDFViewer :pdfUrl="pdfItem" />
          </b-col>
        </b-row>
      </b-container>

      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="danger" @click="cancel()">
          {{ $t("registerForm.buttonTitles.close") }}
        </b-button>
      </template>
    </b-modal>

    <b-modal
      v-model="filterModal"
      ref="modal"
      hide-header
      centered
      size="lg"
      @ok="searchRequest()"
      @cancel="resetFilters()"
    >
      <div class="row justify-content-center">
        <div class="row col-12 p-3 justify-content-center">
          <div class="position-relative col-6">
            <div class="row">
              {{ $t('projectSearchEngine.header.sector')}}
            </div>
            <b-form-select
              class="row"
              :options="sectors"
              v-model="filters.sector"
            />
            <i class="fa-solid fa-x position-absolute --x-icon" @click="resetFilter('sector')"></i>
          </div>
          <div class="position-relative col-6">
            <div class="row">
              {{ $t('projectSearchEngine.header.file_language_T')}}
            </div>
            <b-form-select
              class="row"
              :options="languages"
              v-model="filters.file_language"
            />
            <i class="fa-solid fa-x position-absolute --x-icon" @click="resetFilter('file_language')"></i>
          </div>
        </div>

        <div class="row col-12 p-3 justify-content-center">
          <div class="position-relative col-6">
            <div class="row">
              {{ $t('projectSearchEngine.header.region')}}
            </div>
            <b-form-select
              class="row"
              :options="regions"
              v-model="filters.region"
            />
            <i class="fa-solid fa-x position-absolute --x-icon" @click="resetFilter('region')"></i>
          </div>
          <div class="position-relative col-6">
            <div class="row">
              {{ $t('projectSearchEngine.header.sub_region')}}
            </div>
            <b-form-select
              class="row"
              :options="subRegions"
              v-model="filters.sub_region"
            />
            <i class="fa-solid fa-x position-absolute --x-icon" @click="resetFilter('sub_region')"></i>
          </div>
        </div>

        <div class="row col-12 p-3 justify-content-center">
          <div class="position-relative col-6">
            <div class="row">
              {{ $t('projectSearchEngine.header.country')}}
            </div>
            <b-form-select
              class="row"
              :options="countries"
              v-model="filters.country"
            />
            <i class="fa-solid fa-x position-absolute --x-icon" @click="resetFilter('country')"></i>
          </div>
        </div>
      </div>

      <template #modal-footer="{ ok, cancel }">
        <b-button size="sm" variant="danger" @click="cancel()">
          {{ $t("projectSearchEngine.filterModule.reset") }}
        </b-button>
        <b-button size="sm" variant="success" @click="ok()">
          {{ $t('projectSearchEngine.filterModule.apply')}}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<style lang="scss">

  .searchbar {
    position: relative;

    width: 500px !important;
    height: fit-content !important;

    margin-left: 3em;

  }

  #project-search{
    padding: 5px;
    font-size: 16px;
    width: 100%;

    box-shadow: 0 0 .33em .025em gray;
    border: thin solid lightgray;
    border-radius: 1em;

    padding-left: 1em;
    padding-right: 2.5em;

    width: 100% !important;

    &:focus {
      border: thin solid var(--sustainfinity-navy);
      box-shadow: 0 0 .33em .025em var(--sustainfinity-navy);
    }
  }

  .search-icon{
    transition: scale 100ms;

    position: absolute;

    right: 1em;
    top: 50%;
    transform: translateY(-50%);

    cursor: pointer;
    &:hover{
      scale: 1.33;
    }
  }

  .pse-results-table {
    margin-top: 2em;
    padding-bottom: 200px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-content: center;
    align-items: center;
    width: 100%;

    filter: drop-shadow(0 0 .5em rgb(87, 87, 87));

    > .pse-headers {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-content: center;
      align-items: center;
      width: 100%;

      background-color: var(--sustainfinity-navy);

      color: white;
      border-top-left-radius: 1em;
      border-top-right-radius: 1em;

      > .pse-header {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-content: center;
        align-items: center;
        text-align: left;
        
        padding: 1em .33em 1em .33em;
        border-right: thin solid whitesmoke;

        cursor: pointer;
        &:hover {
          text-decoration: underline;
        }

        &:last-of-type {
          border-right: 0;
        }
      }

      > .pse-pdf-header {
        cursor: default !important;
        pointer-events: none !important;
      }
    }

    > .pse-rows-wrapper {
      width: 100%;

      border-bottom-left-radius: 1em;
      border-bottom-right-radius: 1em;
      overflow: hidden;
      
      > .pse-rows {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-content: center;
        align-items: center;
        background: whitesmoke;
        border-bottom: thin solid lightgray;

        > .pse-cell {
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-content: center;
          align-items: center;
          text-align: left;
          padding: 1em .33em 1em .33em;
        }

        > .pdf-cell {
          justify-content: center;
          text-align: center;
          > i {
            font-size: 25px; 
            color: var(--sustainfinity-green); 
            
            cursor: pointer;
            &:hover {
              filter: brightness(120%);
            }
          }
        }
      }
    }
  }

  /*///// FILTERING //////*/
  .filter-button {
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    text-align: center;

    max-height: 2.5em;

    color: white;

    box-shadow: 0 .2em .5em .05em gray;
    border-radius: .5em;
    margin-right: 2em;
    padding: 1em;
    font-weight: bold;

    background-color: var(--sustainfinity-navy);

    cursor: pointer;
    &:hover {
      filter: hue-rotate(10deg) brightness(105%);
    }
  }

  .--x-icon {
    color: rgb(174, 0, 0);
    right: .8em;
    top: 44%;
    transform: translateY(50%);
    cursor: pointer;
    &:hover {
      filter: brightness(200%);
    }
  }

</style>